import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import { MetaSingleImageImageInitModel, MetaSingleImageImageInitVariables, MetaSingleImageImageModel, MetaSingleImageImageVariables } from '../../../../../models/meta-template/meta-single-image-image.interface';

/**
 * The single creative of a Meta single-image ad. The allowed sizes are
 * enforced on upload by `ImageUploadComponent` (keyed on the template type);
 * that the image is present at all is enforced on save via `requiredFields`.
 */
@Component({
    selector: 'app-meta-single-image-image',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './meta-single-image-image.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './meta-single-image-image.component.scss'
})
export class MetaSingleImageImageComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: MetaSingleImageImageModel = new MetaSingleImageImageInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new MetaSingleImageImageInitVariables()
    }
  }

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof MetaSingleImageImageVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
